<app-dynamic-form
  *ngIf="!codeScreen"
  [error]="error"
  [buttonText]="buttonText"
  [formData]="formData"
  (remeberMeToggle)="onRememberMe($event)"
  (submitted)="login($event)"
>
</app-dynamic-form>

<app-dynamic-form
  *ngIf="codeScreen"
  [error]="error"
  [success]="success"
  [buttonText]="buttonText"
  [formData]="codeFormData"
  (submitted)="verifyCodeAndLogin($event)"
  (newCode)="getNewCode($event)"
>
</app-dynamic-form>
